import React, { Component } from 'react'
import Client from '../ContentFul';

const SoftSkillsContext = React.createContext();


class SoftSkillsProvider extends Component{
    state = {
        softSkills:[],
        loading:true
    };


    getData = async () => {
        try {
            let response = await Client.getEntries({content_type:"softSkills"});
            let softSkills = this.formatAPIs(response.items)
            const sortedSkill = softSkills.sort( (a,b) => {
                const ar = a.order - b.order;
                return ar
            } )
            this.setState({
                softSkills:sortedSkill,
                loading:false
            })
        } catch (error) {
            console.log(error);
        }
    }


    formatAPIs = items => {
        let tempAPI = items.map(item => {
            let id = item.sys.id;
            let data = {...item.fields,id}
            return data;
        })
        return tempAPI;
    }

 

    componentDidMount(){
        this.getData();
    }


    render(){
        return (
            <div>
                {/* <PortfolioContext.Provider value={this.state}>  the same thiing if use speread operator*/}
                <SoftSkillsContext.Provider value={{...this.state,getData:this.getData}}>
                    {this.props.children}
                </SoftSkillsContext.Provider>
            </div>
        )
    }
}

export {SoftSkillsProvider,SoftSkillsContext}
